module.exports = __webpack_public_path__ + "static/media/fc26364e8cd91a68c8f04238b1a03f0f.logo.fc26364e8cd91a68c8f04238b1a03f0f.svg";